// Importing All Images
import company_1 from "./company_1.png";
import company_2 from "./company_2.png";
import company_3 from "./company_3.png";
import company_4 from "./company_4.png";
import company_7 from "./company_7.png";
import company_8 from "./company_8.png";
import advancefaceai_bg from "./advancefaceai-bg.png";
import Aimainimg from "./aimainimg.png";
import ApolloImg from "./apollo.png";
import beyondimg from "./beyondimg.png";
import Cara from "./cara.png";
import Customer1 from "./customer1.png";
import Customer2 from "./customer2.png";
import Customer3 from "./customer3.png";
import Customers from "./customers.png";
import DataAi from "./data-ai.png";
import discovercontacts from "./discovercontacts.png";
import emailfinder from "./emailfinder.png";
import EmailVerifyimg from "./EmailVerifyimg.png";
import FaceAi from "./Face-Ai.png";
import FacebookImg from "./FacebookImg.png";
import fb_1 from "./fb-1.png";
import fb_2 from "./fb-2.png";
import fb_3 from "./fb-3.png";
import Fbextrapage from "./fbextrapage.png";
import Fbgroup from "./fbgroup.png";
import Fbpost from "./fbpost.png";
import Fbuid from "./fbuid.png";
import GmailImg from "./gmail.png";
import GooglestoreImg from "./google-chrome-store.png";
import Group_4083 from "./Group 4083.png";
import DatabaseIcon from "./Icon awesome-database.png";
import Icon_awesome_quote_left from "./Icon awesome-quote-left.png";
import Icon_ionic_ios_star from "./Icon ionic-ios-star.png";
import YoutubeIcon from "./Icon material-subscriptions.png";
import ignitegrowth from "./ignitegrowth.png";
import Leadbud_Dashboard from "./Leadbud Dashboard.png";
import LinkedinImg from "./Linkedin (1).png";
import logo from "./logo.png";
import MagnetSearch from "./magnet-message.png";
import mail from "./mail.png";
import mainbg from "./mainbg.png";
import master from "./master.png";
import SearchMessage from "./mesage-search.png";
import Leadbud_Facebook_Fanpage_Extractor from "./Muzzlead Facebook Fanpage Extractor.png";
import ChatgptImg from "./openai.png";
import Path_7204 from "./Path 7204.png";
import Path_7205 from "./Path 7205.png";
import pay from "./pay.png";
import payooneer from "./payooneer.png";
import paypal from "./paypal.png";
import scraperfb from "./scraperfb.png";
import SearchEngine from "./search-engine (2).png";
import searchenginge_message from "./searchenginge-message.png";
import streamline from "./streamline.png";
import Union_21 from "./Union 21.png";
import Union_22 from "./Union 22.png";
import Union_23 from "./Union 23.png";
import Union_33 from "./Union 33.png";
import Union_34 from "./Union 34.png";
import Union_35 from "./Union 35.png";
import Union_36 from "./Union 36.png";
import Union_37 from "./Union 37.png";
import Union_38 from "./Union 38.png";
import Union_39 from "./Union 39.png";
import Union_40 from "./Union 40.png";
import Union_41 from "./Union 41.png";
import Union_42 from "./Union 42.png";
import unleash from "./unleash.png";
import UserImg from "./user-images.png";
import visa from "./visa.png";
import whitelogo from "./whitelogo.png";
import wirepay from "./wirepay.png";
import WorkingAicara from "./workingaicara.png";
import { HiMiniCheckBadge } from "react-icons/hi2";
import { FaCheckCircle } from "react-icons/fa";

import { IoIosMail , IoIosMailOpen  } from "react-icons/io";
import bannerBg from '../assets/img/landing-page/landing-page-bg.png';
import LandingPageTestimonial from "./landingPageTestimonial.png"
import SVGComponent from "./LoaderSvg"

// Exporting Images as an Object

const images = {
    FaCheckCircle,
    SVGComponent,
    LandingPageTestimonial,
    bannerBg,
    HiMiniCheckBadge,
    IoIosMail,
    IoIosMailOpen,
    company_1,
    company_2,
    company_3,
    company_4,
    company_7,
    company_8,
    advancefaceai_bg,
    Aimainimg,
    ApolloImg,
    beyondimg,
    Cara,
    Customer1,
    Customer2,
    Customer3,
    Customers,
    DataAi,
    discovercontacts,
    emailfinder,
    EmailVerifyimg,
    FaceAi,
    FacebookImg,
    fb_1,
    fb_2,
    fb_3,
    Fbextrapage,
    Fbgroup,
    Fbpost,
    Fbuid,
    GmailImg,
    GooglestoreImg,
    Group_4083,
    DatabaseIcon,
    Icon_awesome_quote_left,
    Icon_ionic_ios_star,
    YoutubeIcon,
    ignitegrowth,
    Leadbud_Dashboard,
    LinkedinImg,
    logo,
    MagnetSearch,
    mail,
    mainbg,
    master,
    SearchMessage,
    Leadbud_Facebook_Fanpage_Extractor,
    ChatgptImg,
    Path_7204,
    Path_7205,
    pay,
    payooneer,
    paypal,
    scraperfb,
    SearchEngine,
    searchenginge_message,
    streamline,
    Union_21,
    Union_22,
    Union_23,
    Union_33,
    Union_34,
    Union_35,
    Union_36,
    Union_37,
    Union_38,
    Union_39,
    Union_40,
    Union_41,
    Union_42,
    unleash,
    UserImg,
    visa,
    whitelogo,
    wirepay,
    WorkingAicara,
};

export default images; // ✅ Correct default export
